<ng-container *ngIf="hasData; else emptyDimension">
  <po-info
    *ngIf="isTruncated"
    p-label="Exibindo"
    [p-value]="chartNote"
    p-orientation="horizontal">
  </po-info>

  <po-chart
    [p-type]="barType"
    [p-categories]="categories"
    [p-series]="series"
    [p-height]="chartHeight">
  </po-chart>

  <po-button
    [p-label]="toggleLabel"
    p-kind="secondary"
    p-size="small"
    p-icon="po-icon-table"
    (p-click)="openTable()">
  </po-button>

  <!-- Modal em vez de expandir no card: com até 200 linhas, o card (metade da largura
       da tela) cortava coluna e linha. O modal usa a viewport inteira, com rolagem
       própria. -->
  <po-modal
    #tableModal
    [p-title]="modalTitle"
    p-size="xl"
    (p-close)="onTableModalClose()">
    <app-costs-breakdown-table
      *ngIf="expanded"
      [keyLabel]="keyLabel"
      [rows]="rows"
      [currency]="currency"
      [totalKeys]="totalKeys"
      [splitResource]="splitResource"
      [period]="period"
      [readingNote]="readingNote"
      [height]="560">
    </app-costs-breakdown-table>
  </po-modal>
</ng-container>

<ng-template #emptyDimension>
  <p class="po-font-text-small">Sem dados neste período.</p>
</ng-template>
